import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import AuthUser from '../../../Components/Auth/AuthUser';
import { Card, CardContent, Typography, Grid, Button, Box, TextField,Dialog, DialogTitle, DialogContent,DialogActions,IconButton } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Chat from "../../../Components/CreditSnapshot/Chat";
import CloseIcon from '@mui/icons-material/Close';
import { Formik, Form } from 'formik';
import TextareaAutosize from '@mui/base/TextareaAutosize';
import swal from "sweetalert";
import * as Yup from 'yup';

let chatSessionId = null;
function FundingShotStep1(props) {
    const { http } = AuthUser();
    const { id } = useParams();
    const [aid, setAID] = useState();
    const [fullWidth, setFullWidth] = React.useState(true);
    const [maxWidth, setMaxWidth] = React.useState('sm');
    const isMobile = useMediaQuery('(max-width:600px)');
    const navigate = useNavigate();
    const [chatEnable, setChatEnable] = React.useState(false);
    const [emailEnable, setEmailEnable] = useState(false);
    const [companyObj, setCompanyObj] = React.useState(false);
    const [isChatOpen, setIsChatOpen] = useState(false);
    const chatbotRef = useRef(null);
    const [isMinimized, setIsMinimized] = useState(true);
    const [startJourneyOpen, setStartJourneyOpen] = useState(false);
    const [assistYouFlag, setAssistYouFlag] = useState(false);
    const [emailChatopen, setEmailChatopen] = useState(false);
    const [messages, setMessages] = useState([]);
    const [creditSnapshotObj, setCreditSnapshotObj] = useState([]);
    const [openIframe, setOpenIframe] = useState(false);
    const [freez, setFreez] = React.useState(false);
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    const funtingNavigate = () => {
        navigate('/En/fundingSnapshot/User/Register/Start/'+`${id}`);
    }
    const handleIFrame = () => {
    setOpenIframe(true);
    }
    
    const handleCloseDialog = () => {
    setOpenIframe(false);
    }
    const openChatPopup = (e) => {
        setIsChatOpen(true);
        var sessionMessagesObj;
        if (localStorage.getItem("sessionMessages") != undefined) {
            sessionMessagesObj = localStorage.getItem("sessionMessages");
        }
        e.preventDefault();
        const element = document.getElementById("chatbotDiv");
        element.style.display = "block";
        setIsMinimized(!isMinimized);

        setStartJourneyOpen(false);
        chatSessionId = localStorage.getItem('chatSessionId');
        if (chatSessionId != null) {
            const sessionMessage1 = localStorage.getItem("sessionMessages");
            if (sessionMessage1) {
                const parsedMessages = JSON.parse(sessionMessage1);
                setMessages(parsedMessages);
            }

            setAssistYouFlag(true);
        } else {
            const Fname = localStorage.getItem('Main_firstName')?.trim() ? localStorage.getItem('Main_firstName') : 'Friend';
            if (sessionMessagesObj > 1) {
                setMessages(sessionMessagesObj);
            }
            if (!assistYouFlag) {
                setAssistYouFlag(true);
            }
        }

    }
    const changeOpenChatPopupValue = (value) => {
        setIsMinimized(value);
    }

    const handleOpenCalendar = () => {
        const updatedUrl = creditSnapshotObj.funding_shot.meeting_link;
        window.open(updatedUrl, '_blank');
    }

    const openEmailChatPopup = () => {
        setStartJourneyOpen(false);
        setIsMinimized(true);
        setEmailChatopen(true);
    }

    const closeStartJourneyOpen = () => {
        setStartJourneyOpen(false);
    }

    const closeEmailChatPopup = () => {
        setStartJourneyOpen(false);
        setEmailChatopen(false);
    }

    const getSnapAID = () => {
        handleFreezStart();
        http.post("/getfundingshotAid", {
            id: id
        })
            .then((res) => {
                handleFreezStop();
                setAID(res.data.data);
                localStorage.setItem('SnapShot_aid', res.data.data);
            })
    }
    //get Snapshot AID function and variable ends
    useEffect(() => {
        getSnapAID();
    }, [])

    const getCreditSnapshotDetails = (value) => {
        setCompanyObj(value);
        setChatEnable(value.funding_shot.enable_chat_support == 1 ? true : false);
        setEmailEnable(value.funding_shot.enable_email_support == 1 ? true : false);
        localStorage.setItem('SnapShot_chat_support', value.funding_shot.enable_chat_support == 1 ? true : false);
        localStorage.setItem('SnapShot_email_support', value.funding_shot.enable_email_support == 1 ? true : false);
        setCreditSnapshotObj(value);
    }

    const sendEmailChatSchema = Yup.object().shape({
    subject: Yup.string()
        .min(2, 'Too Short!')
        .required('Please enter subject'),
    description : Yup.string()
        .min(2, 'Too Short!')
        .required('Please enter Description'),
    email: Yup.string()
    //   .email('Please enter a valid email address') 
    .matches(/^(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24})$/i, "Invalid email format.")
        .required('Please enter your email address'),
    });
    return (
        <>
            <Box>
                <Header aid={aid} logoName={'creditSnapShot'} onValueChange={getCreditSnapshotDetails}/>
                <Box mb={2}>
                    <Card sx={{
                        borderRadius: isMobile?"0px 0 0 90px":"0px 0 0 140px", // Rounded on the left only
                        background: 'linear-gradient(to right, #B9EAFF , #fff)',
                        boxShadow: 0,
                    }}>

                        <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ width: "100%" }}>
                            <Grid item lg={6} md={6} sm={12} xs={12} alignContent={'center'}>
                                <Box alignItems={'center'}>
                                    <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" pb={2}>
                                        <Typography variant={isMobile?'h5':'h4'} fontWeight="bold" color="#435AC2" textAlign="center" gutterBottom>Need Business Funding?</Typography>
                                    </Grid>
                                    <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center">
                                        <Typography variant={isMobile?'body1':'h5'}  fontWeight="bold"  textAlign="center"  gutterBottom>Find Out How Much You Qualify For</Typography>
                                    </Grid>
                                    <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center">
                                        <Typography variant={isMobile?'body1':'h5'}  fontWeight="bold"   textAlign="center" gutterBottom>Up To <b style={{ fontSize:'larger' }} >$750,000</b> With a </Typography>
                                    </Grid>
                                    <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center">
                                        <Typography variant={isMobile?'body1':'h5'}  fontWeight="bold"  textAlign="center" gutterBottom>FREE FUNDING ELIGIBILITY REPORT</Typography>
                                    </Grid>
                                    <Grid container item lg={12} md={12} sm={12} xs={12} mt={2} justifyContent="center">
                                        <Button variant="contained" color="success" id="eligibilityReport" name="eligibilityReport"
                                            onClick={funtingNavigate}
                                            sx={{
                                                padding: '1% 10%',
                                                backgroundColor: "#3FAC19",
                                                fontWeight: "bold",
                                                minWidth: "250px",
                                                minHeight: "50px",
                                                fontSize: isMobile?"15px":"18px",
                                                borderRadius: "10px",
                                                textAlign:"center",

                                            }}>GET MY BUSINESS FUNDING <br/> ELIGIBILITY REPORT NOW</Button>
                                    </Grid>  
                                    <Grid container item lg={12} md={12} sm={12} xs={12} mt={2} justifyContent="center">
                                        <Typography variant="body1" gutterBottom textAlign={ isMobile?"center":"left"}><i>Your Funding Estimate Is FREE And Won't Impact Your Credit. 
                                        {!isMobile && <br />} See Yours In Seconds!</i></Typography>
                                    </Grid>
                                </Box>
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                              
                                    <img
                                        src={require("../../../assets/images/FundingOffers.png")} // update path
                                        alt="Business meeting"
                                        style={{ width: "100%", height: "auto", objectFit: "cover" }}
                                    />
                               
                            </Grid>
                        </Grid>

                    </Card>
                    <Box>
                        {/* <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} sx={{ 
                            display: "flex",
                            justifyContent: isMobile?"center":"flex-end",
                            mt: isMobile ? 2 : 0, 
                            mb: isMobile ? 2 : 3,
                            padding:2 }}>
                                    <Grid item >
                                        <Button varient="outlined"
                                            startIcon={<img src={ChatButton} style={{ width: 30, height: 30, }} />}
                                            sx={{
                                                textTransform: "none !important", minWidth: '250px', maxWidth: '300px', borderRadius: "10px",color:"black",
                                                border:"1px solid #2E67BC",
                                                fontWeight:"bold"
                                            }}
                                        >Chat With Us Now</Button>
                                    </Grid>
                                    
                                    <Grid item sx={{mt: isMobile ? 2 : 0 }}>
                                        <Button
                                            startIcon={<img src={EmailButton} style={{ width: 30, height: 30 }} />}
                                            sx={{
                                                textTransform: "none !important", minWidth: '250px', maxWidth: '300px', borderRadius: "10px",color:"black",
                                                 border:"1px solid #2E67BC",
                                                fontWeight:"bold"
                                            }}
                                        >Email Us Now</Button>
                                    </Grid>
                        </Grid> */}
                        <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} sx={{
                            display: "flex",
                            justifyContent: isMobile ? "center" : "flex-end",
                            mt: isMobile ? 2 : 0,
                            mb: isMobile ? 2 : 3,
                            padding: 2
                        }} >
                            {
                                chatEnable ?
                            <Grid item>
                                <Button varient="outlined"
                                    onClick={openChatPopup}
                                    // disabled={isChatOpen}
                                    startIcon={<img src={require("../../../assets/images/chatforbutton.png")} alt="icon" style={{ width: 30, height: 30 }} />}
                                    sx={{
                                        textTransform: "none !important",
                                        border: "1px solid #2E67BC",
                                        minWidth: '250px', maxWidth: '300px',
                                        color: "black",
                                        alignItems: "center",
                                        borderRadius:"6px",
                                        fontWeight: "bold"// Prevents uppercase transformation
                                    }}>Chat With Us Now</Button>
                            </Grid>
                             : ''
                            }
                            {
                                emailEnable ?
                            <Grid item >
                                <Button startIcon={<img src={require("../../../assets/images/Emailforbutton.png")} alt="icon" style={{ width: 30, height: 30 }} />}
                                    onClick={openEmailChatPopup}
                                    sx={{
                                        textTransform: "none",
                                        border: "1px solid #2E67BC",
                                        minWidth: '250px', maxWidth: '300px',
                                        color: "black",
                                        alignItems: "center",
                                        borderRadius:"6px",
                                        fontWeight: "bold" // Prevents uppercase transformation
                                    }}>Email Us Now</Button>
                            </Grid>
                             : ''
                            }

                            {
                                creditSnapshotObj && creditSnapshotObj.funding_shot && creditSnapshotObj.funding_shot.step1_link ? 
                                    <Grid item >
                                        <Button
                                            onClick={handleIFrame}
                                            startIcon={<img src={require("../../../assets/images/youtubeicon.png")} alt="icon" style={{ width: 30, height: 30 }} />}
                                            sx={{
                                                textTransform: "none",
                                                border: "1px solid #2E67BC", // Prevents uppercase transformation
                                                minWidth: '250px', maxWidth: '300px',
                                                alignItems: "center",
                                                color: "black",
                                                fontWeight: "bold",
                                                borderRadius:"6px",
                                            }}>Watch Video
                                        </Button>
                                    </Grid>
                                 : ''
                            } 
                            <Grid item >
                                {
                                    creditSnapshotObj && creditSnapshotObj.funding_shot && creditSnapshotObj.funding_shot.enable_meeting_link ? 
                                    <Button
                                    onClick={handleOpenCalendar}
                                    startIcon={<img src={require("../../../assets/images/meeting.png")} alt="icon" style={{ width: 30, height: 30 }} />}
                                    sx={{
                                        textTransform: "none",
                                        border: "1px solid #2E67BC", // Prevents uppercase transformation
                                        minWidth: '250px', maxWidth: '300px',
                                        alignItems: "center",
                                        color: "black",
                                        fontWeight: "bold",
                                        borderRadius:"6px",
                                    }}>Book A Meeting
                                </Button>
                                : ''
                                }
                                
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                        <Chat mEmail={null} firstName={null} isMinimized={isMinimized} changeOpenChatPopupValue={changeOpenChatPopupValue} openEmailChatPopup={openEmailChatPopup} companyId={companyObj.company_master_id} source="snapshot" />

                    </Box>
                </Box>
                <Footer />
            </Box>

            {isChatOpen && (
                <Box
                    sx={{
                        position: "fixed",
                        bottom: "2%",
                        right: "2%",
                        cursor: "pointer",
                    }}
                    onClick={openChatPopup}
                >
                    <img
                        src={require("../../../assets/images/chatforbutton.png")}
                        alt="Chat Icon"
                        style={{
                        width: "70px",
                        height: "70px",
                        borderRadius: "50%",
                        boxShadow:
                            "0px 4px 8px rgba(0, 0, 0, 0.2), 0px 8px 16px rgba(0, 0, 0, 0.19)",
                        }}
                    />
                </Box>
            )}

            <Formik
                initialValues={{
                subject: '',
                description : '',
                email : ''
                }}
                validationSchema={sendEmailChatSchema}
                onSubmit={async (values, { resetForm }) => {
                handleFreezStart();
                http.post("/sendChatEmail", {
                    email : values.email,
                    subject : values.subject,
                    description : values.description,
                    companyId : companyObj.company_master_id,
                    source : "snapshot"
                })
                .then((res) => {
                    if (res.data.success === true) {
                    swal({
                        title: "Success",
                        text: res.data.message,
                        icon: "success",
                        button: "Ok",
                    });
                    handleFreezStop();
                    }else{
                    // alert("something went wrong");
                    handleFreezStop();
                    }
                })
                closeEmailChatPopup();
                resetForm();
                }}
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                <Dialog
                    open={emailChatopen}
                    onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        // setDeleteOpen(false)
                    }
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                <DialogTitle id="alert-dialog-title">
                    {/* Delete Pid */}
                    <Grid container item lg={12} md={12} sm={12} xs={12} sx={{justifyContent:"space-between"}}>
                    <Grid item lg={10} md={10} sm={10} xs={10}>
                        <Typography level="h5" sx={{textAlign:"center"}}>Send Us The Email</Typography>
                    </Grid>
                    <Grid item lg={2} md={2} sm={2} xs={2} sx={{textAlign:"right"}}>
                        <CloseIcon  onClick={closeEmailChatPopup}/>
                    </Grid>
                    </Grid>
                </DialogTitle>
                <DialogActions >
                <Grid container item lg={12} md={12} sm={12} xs={12} >
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                            id="outlined-start-adornment"
                            type="text"
                            label="From Email Address"
                            fullWidth
                            variant="outlined"
                            size="small"
                            margin="dense"
                            autoComplete="email"
                            value={values.email}
                            onChange={handleChange('email')}
                            onBlur={handleBlur('email')} 
                            InputLabelProps={{
                                shrink: Boolean(values.email), 
                            }}
                            />
                            {touched.email && errors.email ? <div className="error">{errors.email}</div> : null}
                        </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                        id="outlined-start-adornment"
                        type="text"
                        label="Subject"
                        fullWidth
                        variant="outlined"
                        size="small"
                        margin='dense'
                        autoComplete='subject'
                        value={values.subject}
                        onChange={handleChange('subject')}
                        onBlur={handleBlur('subject')}
                        InputLabelProps={{
                            shrink: Boolean(values.subject)
                        }}
                        /> 
                        {touched.subject && errors.subject ? <div className='error'>{errors.subject}</div> : null}
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12} mt={2}>
                        <TextareaAutosize
                            placeholder="Message"
                            type="text"
                            size="small"
                            fullWidth
                            name='description'
                            autoComplete='description'
                            id='description'
                            onChange={handleChange('description')}
                            onBlur={handleBlur('description')}
                            value={values.description}
                            maxRows={7}
                            minRows={4}
                            
                            style={{
                            width: '100%', // Ensures full width
                            // padding: '8px', // Optional for better spacing
                            boxSizing: 'border-box', // Ensures padding doesn't affect width
                        }}
                        />
                        {touched.description && errors.description ? <div className='error'>{errors.description}</div> : null}
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} mt={2} sx={{ justifyContent: "center", display: "flex"}}>
                    <Button variant="contained" sx={{ minWidth: 200 }} color="success" 
                        onClick={handleSubmit}
                        >
                        Send
                    </Button>
                    </Grid>
                </Grid>
                </DialogActions>
                </Dialog>
            )}
            </Formik>

            {/* Iframe Dialog Start */}
            <Dialog open={openIframe}
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseDialog();
                    }
                }}
                fullWidth={fullWidth}
                maxWidth={maxWidth}>
                <DialogTitle sx={{ bgcolor: "#F6FAFF" }}>
                    <Grid container item xs>
                        <Grid item xs>
                            <Typography level="h4" color="primary">Learn More About Us</Typography>
                        </Grid>
                        <Grid item xs sx={{ textAlign: "right" }}>
                            <IconButton
                                aria-label="close"
                                onClick={handleCloseDialog}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <Grid container item lg={12} md={12} sm={12} xs={12} mt={2} sx={{ justifyContent : "center" }}>
                        <iframe
                            width="560"
                            height="315"
                            src={creditSnapshotObj && creditSnapshotObj.funding_shot ? creditSnapshotObj.funding_shot.step1_link : ''}
                            title="Video Player"
                            // frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </Grid>
                </DialogContent>
                {/* </DialogActions> */}
            </Dialog>
            {/* Iframe Dialog End */}
        </>
    );
}





export default FundingShotStep1;